import * as React from 'react'
import Tooltip from '@mui/material/Tooltip'
import PropTypes from 'prop-types'
import {StyledPaper, StyledToggleButton, StyledToggleButtonGroup} from './ToggleButtonGroupStyles'

export default function ToggleButtonGroup({
  onSelection,
  toggleButtons,
  defaultValue,
  isMapContainer,
  disabled,
  isTextToggleButton = false,
  onSelectionSuccess = () => {}
}) {
  const [value, setValue] = React.useState(defaultValue)
  const handleAlignment = (event, value) => {
    if (value != null) {
      setValue(value)
      isTextToggleButton ? onSelection(value) : onSelection(value === 'table')
      onSelectionSuccess()
    }
  }

  return (
    <StyledPaper elevation={0} isMapContainer={isMapContainer}>
      <StyledToggleButtonGroup
        disabled={disabled}
        size="small"
        value={value}
        exclusive
        onChange={handleAlignment}
        aria-label="view mode"
      >
        {toggleButtons.map((data) => (
          <ToggleButtonWithTooltip
            key={data.toggleBtnProps?.value}
            tooltipProps={data.tooltipProps}
            toggleBtnProps={data.toggleBtnProps}
          />
        ))}
      </StyledToggleButtonGroup>
    </StyledPaper>
  )
}

ToggleButtonGroup.propTypes = {
  onSelection: PropTypes.func,
  toggleButtons: PropTypes.array,
  defaultValue: PropTypes.string,
  isMapContainer: PropTypes.bool,
  disabled: PropTypes.bool,
  isTextToggleButton: PropTypes.bool,
  onSelectionSuccess: PropTypes.func
}

export const ToggleButtonWithTooltip = ({tooltipProps, toggleBtnProps}) => {
  return (
    <Tooltip {...tooltipProps}>
      <span>
        <StyledToggleButton {...toggleBtnProps} isText={Boolean(toggleBtnProps?.text)}>
          {toggleBtnProps.icon || toggleBtnProps.text}
        </StyledToggleButton>
      </span>
    </Tooltip>
  )
}
ToggleButtonWithTooltip.propTypes = {
  tooltipProps: PropTypes.object,
  toggleBtnProps: PropTypes.object
}
